import React from "react";

import Chip from "../index";

export default function Invoice({ value, ...props }) {
  const items = {
    DRAFT: {
      color: "default",
      tooltip: "Created automatically or manually, awaiting further input",
    },
    SUBMITTED: {
      color: "info",
      tooltip: "Awaiting approval by appropriate Accounting staff",
    },
    AUTHORISED: {
      color: "primary",
      tooltip: "Approved by Accounting, waiting to be sent to Client",
    },
    SENT: {
      color: "primary",
      tooltip: "Approved by Accounting, sent to Client",
    },
    DELETED: {
      color: "dark",
    },
    VOIDED: {
      color: "dark",
    },
    PAID: {
      color: "success",
    },
  };

  const item = items[value] || {
    color: "default",
  };

  return (
    <Chip value={value} tooltip={item.tooltip} color={item.color} {...props} />
  );
}
